import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';

export default class AccountService {
    static findSubmissionSummariesByAccount(
        accountNumber,
        additionalHeaders = {}
    ) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewaySubmission'),
            'findSubmissionSummariesByAccount',
            [accountNumber],
            additionalHeaders
        );
    }
}
